import { useNavigate, useLocation } from 'react-router-dom'
import { Book, FileCheck, FolderOpen } from 'lucide-react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useProjectContext } from '@/lib/context/ProjectContext'

interface RequirementsOpsLayoutProps {
    children: React.ReactNode
}

export default function RequirementsOpsLayout({ children }: RequirementsOpsLayoutProps) {
    const navigate = useNavigate()
    const location = useLocation()
    const { selectedProject } = useProjectContext()

    const getActiveTab = () => {
        if (location.pathname.includes('/requirements-ops/req-specs')) return 'req-specs'
        if (location.pathname.includes('/requirements-ops/requirements')) return 'requirements'
        return 'req-specs'
    }

    const handleTabChange = (value: string) => {
        navigate(`/requirements-ops/${value}`)
    }

    return (
        <div className="p-8 space-y-6">
            <div>
                <h1 className="text-3xl font-bold">Requirements Ops</h1>
                <p className="text-muted-foreground mt-1">
                    {selectedProject ? (
                        <>
                            Requirement specifications and traceability for{' '}
                            <span className="font-medium text-foreground">{selectedProject.name}</span>
                        </>
                    ) : (
                        'Manage requirement specifications and track requirements'
                    )}
                </p>
            </div>

            <Tabs value={getActiveTab()} onValueChange={handleTabChange} className="w-full">
                <TabsList className="grid w-full max-w-2xl grid-cols-2">
                    <TabsTrigger value="req-specs">
                        <Book className="h-4 w-4 mr-2" />
                        Req Specifications
                    </TabsTrigger>
                    <TabsTrigger value="requirements">
                        <FileCheck className="h-4 w-4 mr-2" />
                        Requirements
                    </TabsTrigger>
                </TabsList>
            </Tabs>

            {!selectedProject ? (
                <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-20">
                    <FolderOpen className="h-12 w-12 text-gray-300" />
                    <h3 className="mt-4 text-lg font-semibold text-gray-600">No Project Selected</h3>
                    <p className="text-sm text-muted-foreground mt-1">
                        Select a project from the header to continue.
                    </p>
                </div>
            ) : (
                children
            )}
        </div>
    )
}